import { useMemo } from 'react';

import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

import {
  MarkdownBlockquote,
  MarkdownSpan,
  MarkdownCode,
  MarkdownDel,
  MarkdownEm,
  MarkdownH1,
  MarkdownH2,
  MarkdownH3,
  MarkdownH4,
  MarkdownH5,
  MarkdownH6,
  MarkdownHr,
  MarkdownImg,
  MarkdownLi,
  MarkdownLink,
  MarkdownOl,
  MarkdownP,
  MarkdownPre,
  MarkdownStrong,
  MarkdownTable,
  MarkdownTableCell,
  MarkdownTbody,
  MarkdownThead,
  MarkdownTr,
  MarkdownUl
} from './MarkdownComponents';

import type { Components } from 'react-markdown';

const Markdown = ({ children }: { children: string }) => {
  const components: Components = useMemo(
    () => ({
      a: MarkdownLink,
      p: MarkdownP,
      strong: MarkdownStrong,
      em: MarkdownEm,
      del: MarkdownDel,
      h1: MarkdownH1,
      h2: MarkdownH2,
      h3: MarkdownH3,
      h4: MarkdownH4,
      h5: MarkdownH5,
      h6: MarkdownH6,
      img: MarkdownImg,
      blockquote: MarkdownBlockquote,
      code: MarkdownCode,
      pre: MarkdownPre,
      hr: MarkdownHr,
      ul: MarkdownUl,
      ol: MarkdownOl,
      li: MarkdownLi,
      table: MarkdownTable,
      thead: MarkdownThead,
      tbody: MarkdownTbody,
      tr: MarkdownTr,
      th: MarkdownTableCell,
      td: MarkdownTableCell,
      span: MarkdownSpan
    }),
    []
  );

  return (
    <ReactMarkdown
      components={components}
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkGfm]}
    >
      {children}
    </ReactMarkdown>
  );
};

export default Markdown;
